module.exports = __webpack_public_path__ + "img/forth_step.c6e1e2a1.png";